export default __webpack_public_path__ + "static/media/promoCardsHero.22f1f287.jpg";